import { render } from "./SubNav.vue?vue&type=template&id=2329e7a2&scoped=true"
import script from "./SubNav.vue?vue&type=script&lang=js"
export * from "./SubNav.vue?vue&type=script&lang=js"

import "./SubNav.vue?vue&type=style&index=0&id=2329e7a2&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-2329e7a2"

export default script